import React from "react";
import { AppBar, Toolbar, Button, Typography, Link } from "@mui/material";
import TwitterIcon from "@mui/icons-material/X";
import TelegramIcon from "@mui/icons-material/Telegram";
import logoImg from "../img/grethulvingLogo.png";

const Navbar = () => {
  return (
    <AppBar position="static" sx={{ bgcolor: "black", color: "#AFEEEE" }}>
      <Toolbar>
        <img src={logoImg} alt="Logo" style={{ marginRight: 16, height: 40 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          TEH GRET HULVING
        </Typography>
        <Button
          color="inherit"
          component={Link}
          href="https://twitter.com/theGreatHalving"
        >
          <TwitterIcon />
        </Button>
        <Button
          color="inherit"
          component={Link}
          href="https://t.me/+vZNatepkHvo3ODc0"
        >
          <TelegramIcon />
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
